import { ofType } from 'redux-observable';
import { filter, map, mergeMap } from 'rxjs/operators';

import { KEY_DOWN_EVENT, PASTE } from '../../etc/constants';
import { createAction } from '../actions';
import { smilesToMol } from '../conversion';

import { CLIPBOARD_PASTE_FULFILL } from './molecule-object.actions';
import * as interpreter from './reducer/interpreter';

export function parseClipboardSmiles(action$, state$) {
  return action$.pipe(
    ofType(KEY_DOWN_EVENT),
    map(action => interpreter.interpretKeys(null, action)),
    filter(effect => effect?.type === PASTE),
    mergeMap(async () => {
      const { clipboard } = state$.value.moleculeObject;
      const { molsBySmiles } = state$.value.moleculeUtil;

      try {
        const permission = await navigator.permissions.query({
          name: 'clipboard-read',
        });

        if (permission.state !== 'granted' && permission.state !== 'prompt') {
          return createAction(CLIPBOARD_PASTE_FULFILL, {
            result: clipboard,
          });
        }

        const clipboardText = await navigator.clipboard.readText();

        if (molsBySmiles[clipboardText]) {
          return createAction(CLIPBOARD_PASTE_FULFILL, {
            result: molsBySmiles[clipboardText],
          });
        }

        const newMol = await smilesToMol(clipboardText);

        return createAction(CLIPBOARD_PASTE_FULFILL, {
          result: newMol,
        });
      } catch (error) {
        return createAction(CLIPBOARD_PASTE_FULFILL, {
          result: clipboard,
        });
      }
    })
  );
}
